// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"fa53ce5affb28313141e","453":"14dddb6e0fa965cdeed9"}[chunkId] + ".js";
};